import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=85d419c0&scoped=true&"
import script from "./Revenue.vue?vue&type=script&lang=js&"
export * from "./Revenue.vue?vue&type=script&lang=js&"
import style0 from "./Revenue.vue?vue&type=style&index=0&id=85d419c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d419c0",
  null
  
)

export default component.exports